var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{attrs:{"name":"toolbar"}})],1),_c('Drawer'),_c('v-main',[_c('Update'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('Notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }